var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 115.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1aa4e0;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.74,20.76a5.19,5.19,0,0,0,0,10.38h22L37.36,42.2a5.19,5.19,0,0,0,2.57,9.7H64.84a1,1,0,0,1,1,1V64.88a1.07,1.07,0,0,1-.3.74L56.23,75a1,1,0,0,1-1.46,0L43.6,63.79a5.19,5.19,0,1,0-7.34,7.34L51.83,86.7a5.18,5.18,0,0,0,7.34,0L74.74,71.13a5.19,5.19,0,0,0,1.52-3.67V46.71a5.19,5.19,0,0,0-5.19-5.19H59.47L78.83,30.45a5.19,5.19,0,0,0-2.57-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.57,0A15.57,15.57,0,0,0,.16,17.77l8.14,57a15.6,15.6,0,0,0,5.16,9.51L45.25,112.1a15.58,15.58,0,0,0,20.5,0L97.54,84.28a15.6,15.6,0,0,0,5.16-9.51l8.14-57A15.57,15.57,0,0,0,95.43,0ZM10.43,16.3a5.19,5.19,0,0,1,5.14-5.92H95.43a5.19,5.19,0,0,1,5.14,5.92l-8.15,57a5.13,5.13,0,0,1-1.72,3.17L58.92,104.28a5.18,5.18,0,0,1-6.84,0L20.3,76.47a5.13,5.13,0,0,1-1.72-3.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.34c437f6fcb1645bbcdc26742ca7423d.svg";
export { ForwardRef as ReactComponent };